import { render, staticRenderFns } from "./Discos.vue?vue&type=template&id=643c68e6&scoped=true"
import script from "./Discos.vue?vue&type=script&lang=js"
export * from "./Discos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643c68e6",
  null
  
)

export default component.exports